import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import confirm from '../../ea/confirm.js'
import { getChild } from '../rte.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: async (
    button
  ) => {
    const { dataset, form, ownerDocument } = button
    const iframe = one('iframe[data-rte]', form)
    const { contentDocument, contentWindow } = iframe
    const { body } = contentDocument
    const { confirm: message } = dataset
    const { value } = one(`input[name='msg_text_default']`, ownerDocument)

    queueMicrotask(async () => {
      if (await confirm(message)) {
        body.innerHTML = value ? value : ''

        if (value !== '') {
          const lastTag = getChild(body)
          const range = contentDocument.createRange()
          const selection = contentDocument.getSelection()

          range.selectNodeContents(lastTag)
          range.collapse(false)
          selection.removeAllRanges()
          selection.addRange(range)
        }

        await contentWindow.focus()

        if (value !== '') {
          await body.focus() // FOR CHROME
          body.selectionStart = 1
          body.selectionEnd = 1
        }
      }
    })
  }
})

export default button => {
  onClick.listen(button)
}